import { fromInteger, toInteger } from '@repo/money'
import type { PlaceBetRequestedDTO, BetDTO } from 'src/actions/types'
import type { Bet } from 'src/types/domain/Bet'
import { BetStatusMap } from '../BetStatusMap'

export const fromBetDTO = (betDTO: BetDTO): Bet => ({
  id: betDTO.id,
  playerId: betDTO.playerId,
  raceId: betDTO.roundId,
  raceConfigurationId: betDTO.gameId,
  betAmount: fromInteger(betDTO.amount, betDTO.currency),
  currency: betDTO.currency,
  betDetails: betDTO.details,
  status: BetStatusMap.fromBetStatusDTO(betDTO.status),
  potentialPayout: fromInteger(betDTO.potentialPayout, betDTO.currency),
  createdAt: betDTO.createdAt,
  // Crash game fields
  ...(betDTO.cashoutMultiplier !== undefined && { cashoutMultiplier: betDTO.cashoutMultiplier }),
  ...(betDTO.actualPayout !== undefined && {
    potentialPayout: fromInteger(betDTO.actualPayout, betDTO.currency)
  })
})

export const toPlaceBetRequestedDTO = (
  sessionId: string,
  bet: Bet,
  correlationId: string
): PlaceBetRequestedDTO => ({
  sessionId,
  id: bet.id,
  playerId: bet.playerId,
  roundId: bet.raceId,
  gameId: bet.raceConfigurationId,
  amount: toInteger(bet.betAmount, bet.currency),
  currency: bet.currency,
  details: bet.betDetails,
  correlationId,
  ...(bet.autoCashoutMultiplier !== undefined && { autoCashoutMultiplier: bet.autoCashoutMultiplier })
})
